/* External */
import { memo } from 'react';
import PropTypes from 'prop-types';

/* Ott-common */
import Button from '@dtvgo/button';

/* Utils */
import withInteractiveFocusable from '../../hocs/withInteractiveFocusable.hoc';

/* Styles */
import './FocusableButton.scss';

export function BaseFocusableButton({
  children,
  primary = false,
  bordered = false,
  className = '',
  disabled = false,
  focused = false,
  icon = '',
  onMouseDown,
  onMouseEnter,
}) {
  return (
    <Button
      primary={primary}
      className={
      `dtv-html5-c-focusable-button ${
        focused ? 'dtv-html5-c-focusable-button--focused' : ''
      } ${className}`
    }
      disabled={disabled}
      bordered={bordered}
      icon={icon}
      onMouseDown={onMouseDown}
      onMouseEnter={onMouseEnter}
    >
      {children}
    </Button>
  );
}

BaseFocusableButton.propTypes = {
  children: PropTypes.node,
  primary: PropTypes.bool,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  bordered: PropTypes.bool,
  focused: PropTypes.bool,
  icon: PropTypes.string,
  onMouseDown: PropTypes.func,
  onMouseEnter: PropTypes.func,
};

export default memo(withInteractiveFocusable()(memo(BaseFocusableButton)));
